/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Filters from '../../../../components/Filters';
import Button from '../../../../components/Button';
import { ControlTable } from '../../../../components/Table';
import useForm from '../../../../hooks/useForm';
import { getParams } from '../../../../utils/params';
import systemAlert from '../../../../utils/systemAlert';
import { getDay } from '../../../../utils/date';
import { cloneDeep, forEach, isEmpty, uniqBy } from 'lodash';
import { createBanksTransItems, createBankTransRecordsClient } from '../../../../apis/finances/bank';
import { getCashReceiptsPurchaseList, getCashReceiptsSalesList } from '../../../../apis/cash-receipts';
import { cleanObj } from '../../../../utils/cleanObj';

const CashReceiptsListModal = ({ open, setOpen, bankData, detailSubmit }) => {
  const [fields, setFields] = useState([
    { title: "거래일자", key: "tradeTime", type: "date" },
    { title: "승인번호", key: "apprNo" },
    { title: "발급수단번호", key: "frPartNo" },
    { title: "공제구분", key: "ddcYn" },
    { title: "공급가액", key: "supAmt", type: 'comma' },
    { title: "부가세", key: "taxAmt", type: 'comma' },
    { title: "봉사료", key: "tip", type: 'comma' },
    { title: "총 거래금액", key: "totAmt", type: 'comma' },
  ]);

  const [filters] = useState([
    {
      title: '조회기간',
      type: 'customdatepicker',
      key: "range.tradeTime"
    },
    {
      title: "합계금액",
      key: "search.totAmt",
      placeholder: '합계금액 입력',
      type: 'number'
    },
  ]);

  useEffect(() => {
    if (bankData[0].inAmt > 0) {
      setFields([
        { title: "거래일자", key: "tradeTime", type: "date" },
        { title: "승인번호", key: "apprNo" },
        { title: "발급수단번호", key: "frPartNo" },
        { title: "거래구분", key: "trGb" },
        { title: "공급가액", key: "supAmt", type: 'comma' },
        { title: "부가세", key: "taxAmt", type: 'comma' },
        { title: "봉사료", key: "tip", type: 'comma' },
        { title: "총 거래금액", key: "totAmt", type: 'comma' },
        {
          title: "거래처",
          key: "client",
          className: "text-align-right",
          onValue: (value, field, data) => {
            return (
              !isEmpty(value) &&
              (
                <>{value.name}</>
              )
            );
          }
        },
      ]);
    }
  }, [bankData]);

  const cancel = () => {
    setOpen(false);
    reset();
  };

  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    reset
  } = useForm(
    {
      order: [{ tradeTime: "desc" }],
      range: {
        tradeTime: [getDay(90), getDay()],
      },
      search: {
        totAmt: bankData[0].inAmt > 0 ? bankData[0].inAmt : bankData[0].outAmt,
      },
      page: 0,
      limit: 10
    },
  );

  useEffect(() => {
    if (open && bankData) {
      submit(form);
      setSubmit(submit);
    }
  }, [open]);

  const submit = (params) => {
    const _params = cloneDeep(params);
    if (!isEmpty(_params["range.tradeTime"])) {
      _params.range.tradeTime = {
        from: _params["range.tradeTime"][0],
        to: _params["range.tradeTime"][1]
      };

      delete _params["range.tradeTime"];
    }
    setIsLoading(true);
    if (bankData[0].inAmt > 0) {
      getCashReceiptsSalesList(getParams(_params)).then((res) => {
        setTotal(res.data.totalCount);
        setList(res.data.list);
      }).catch(() => { }).finally(() => { setIsLoading(false); });
    }

    if (bankData[0].outAmt > 0) {
      getCashReceiptsPurchaseList(getParams(_params)).then((res) => {
        setTotal(res.data.totalCount);
        setList(res.data.list);
      }).catch(() => { }).finally(() => { setIsLoading(false); });
    }
  };

  const handleApply = () => {
    let body = {
      bankTransIdxes: [],
      cashReceiptSalesIdxes: [],
      cashReceiptPurchaseIdxes: [],
    };
    const list = [];
    const clientList = [];
    for (const obj of bankData) {
      body.bankTransIdxes.push(obj.idx);
    }

    for (const obj of selectedList) {
      if (bankData[0].inAmt > 0) {
        body.cashReceiptSalesIdxes.push(obj.idx);
      }

      if (bankData[0].outAmt > 0) {
        body.cashReceiptPurchaseIdxes.push(obj.idx);
      }
    }

    forEach(selectedList, selected => {
      // 현금영수증에 매핑된 거래처를 리스트에 넣어줌
      if (!isEmpty(selected.client)) {
        clientList.push(selected.client);
      }
    });
    const uniqClientList = uniqBy(clientList, 'idx');

    forEach(bankData, data => {
      // 은행 내역에 거래처가 있을 경우, 은행에 매핑되어 있는 거래처 + 현금영수증 거래처
      let totalClientList = [...uniqClientList];
      if (!isEmpty(data.clients)) {
        forEach(data.clients, client => {
          totalClientList.push(client);
        });
      }

      forEach(uniqBy(totalClientList, 'idx'), client => {
        if (!isEmpty(client)) {
          list.push({
            clientIdx: client.idx,
            bankTransIdx: data.idx,
            moneyIn: data.inAmt > 0 ? Math.floor(data.inAmt / uniqBy(totalClientList, 'idx').length) : 0,
            moneyOut: data.outAmt > 0 ? Math.floor(data.outAmt / uniqBy(totalClientList, 'idx').length) : 0,
          });
        }
      });
    });

    cleanObj(body);

    systemAlert('선택된 현금영수증 내역을 해당 은행 입출금 내역 연관데이터로 등록하시겠습니까?',
      {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '확인',
            onClick: () => {
              createBanksTransItems(body).then(() => {
                createBankTransRecordsClient({ list }).then(() => {
                  detailSubmit(); cancel();
                });
              });
            }
          }
        ]
      });
  };

  return (
    <>
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange} />
      <ControlTable
        fields={fields}
        list={list}
        selectedList={selectedList}
        setSelected={setSelectedList}
        isLoading={isLoading}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        isControl={true}
        submit={handleSubmit}
      />
      <div className="submit-button-wrap float-right margin-top-32">
        <Button
          className="button"
          size="lg"
          label="취소"
          color="text"
          action={cancel}
        />
        <Button
          className="button"
          size="lg"
          label="적용하기"
          disabled={isEmpty(selectedList)}
          action={handleApply}
        />
      </div>
    </>
  );
};

export default CashReceiptsListModal;